'use client';

import { Spinner } from '@eliadmin/core/src/components/ui/spinner';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function PortalContentLoader({ className }: { className?: string }) {
  const { t } = useTranslations();

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={cn(
        'flex min-h-[360px] w-full flex-col items-center justify-center gap-4 py-16 sm:min-h-[480px]',
        className,
      )}
    >
      <span aria-hidden="true">
        <Spinner className="h-12 w-12 text-primary motion-reduce:animate-none" />
      </span>
      <span className="text-sm text-muted-foreground">{t('Načítava sa…')}</span>
    </div>
  );
}

export function PortalContentError({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslations();

  return (
    <div role="alert" className="flex min-h-[360px] flex-col items-center justify-center gap-4 p-6">
      <p>{t('text1472')}</p>
      <button
        type="button"
        onClick={onRetry}
        className="rounded-full border border-primary px-6 py-3 text-primary hover:bg-primary hover:text-primary-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
      >
        {t('Skúsiť znova')}
      </button>
    </div>
  );
}
